import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=06c3cef2&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"
import style0 from "./NewsView.vue?vue&type=style&index=0&id=06c3cef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c3cef2",
  null
  
)

export default component.exports